import { z } from 'zod'
import { Model } from '../../_kernel/architecture'

export const PriceDistributionValidation = z.object({
  value: z.number(),
  count: z.number(),
})

export class PriceDistribution extends Model {
  static create({ value, count }: z.infer<typeof PriceDistributionValidation>) {
    PriceDistributionValidation.parse({ value, count })
    return new PriceDistribution(value, count)
  }

  static fromJSON({ value, count }: { value: number; count: number }) {
    PriceDistributionValidation.parse({ value, count })
    const model = new PriceDistribution(value, count)

    return model
  }

  constructor(
    private readonly _value: number,
    private readonly _count: number
  ) {
    super()
  }

  getValue() {
    return this._value
  }

  getCount() {
    return this._count
  }

  toJSON() {
    return {
      value: this._value,
      count: this._count,
    }
  }
}
